import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const SearchIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    clipPath: "url(#clip0_15916_36154)"
  }, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4937 18.4793C18.6504 18.3224 18.8366 18.1979 19.0414 18.113C19.2463 18.0281 19.4659 17.9844 19.6876 17.9844C19.9094 17.9844 20.129 18.0281 20.3338 18.113C20.5387 18.1979 20.7248 18.3224 20.8815 18.4793L27.3784 24.9762C27.6951 25.2926 27.873 25.7218 27.8732 26.1695C27.8733 26.6171 27.6957 27.0465 27.3793 27.3631C27.0628 27.6798 26.6336 27.8578 26.1859 27.8579C25.7383 27.8581 25.3089 27.6804 24.9923 27.364L18.4954 20.8671C18.3385 20.7104 18.214 20.5243 18.1291 20.3194C18.0442 20.1146 18.0005 19.895 18.0005 19.6732C18.0005 19.4514 18.0442 19.2319 18.1291 19.027C18.214 18.8221 18.3385 18.636 18.4954 18.4793H18.4937Z",
    fill: color
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8438 21.1094C13.0626 21.1094 14.2695 20.8693 15.3955 20.4029C16.5216 19.9365 17.5447 19.2528 18.4066 18.391C19.2684 17.5291 19.9521 16.506 20.4185 15.3799C20.8849 14.2539 21.125 13.047 21.125 11.8281C21.125 10.6093 20.8849 9.4024 20.4185 8.27634C19.9521 7.15029 19.2684 6.12713 18.4066 5.26529C17.5447 4.40345 16.5216 3.71979 15.3955 3.25337C14.2695 2.78694 13.0626 2.54688 11.8438 2.54688C9.38221 2.54688 7.02149 3.52472 5.28092 5.26529C3.54034 7.00586 2.5625 9.36658 2.5625 11.8281C2.5625 14.2897 3.54034 16.6504 5.28092 18.391C7.02149 20.1315 9.38221 21.1094 11.8438 21.1094ZM22.8125 11.8281C22.8125 14.7372 21.6569 17.5272 19.5998 19.5842C17.5428 21.6412 14.7528 22.7969 11.8438 22.7969C8.93466 22.7969 6.14471 21.6412 4.08767 19.5842C2.03063 17.5272 0.875 14.7372 0.875 11.8281C0.875 8.91903 2.03063 6.12909 4.08767 4.07205C6.14471 2.01501 8.93466 0.859375 11.8438 0.859375C14.7528 0.859375 17.5428 2.01501 19.5998 4.07205C21.6569 6.12909 22.8125 8.91903 22.8125 11.8281Z",
    fill: color
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "clip0_15916_36154"
  }, __jsx("rect", {
    width: "27",
    height: "27",
    fill: "white",
    transform: "translate(0.875 0.859375)"
  }))));
};
export default SearchIcon;